import DayType from 'domains/DayType'

const dayOptions = [
	{ description: DayType.CONSECUTIVE_DAY.description, value: DayType.CONSECUTIVE_DAY.name },
	{ description: DayType.WORKDAY.description, value: DayType.WORKDAY.name }
]

export default dayOptions
